import { useReducer } from "react";

const initialState = [];

const reducer = (state, action) => {
  const numberOfPromptLines = state.filter((r) => r.type === "prompt").length;
  const numberOfOutputLines = state.filter((r) => r.type === "output").length;
  switch (action.type) {
    case "prompt":
      return [...state, { title: `Prompt ${numberOfPromptLines + 1}`, type: "prompt", content: action.payload.prompt }];
    case "textChunk":
      const existing = state.find((r) => r.type === "output" && r.index === action.payload.content.index && r.inferenceBlockCount === action.payload.content.inferenceBlockCount);
      if (!existing) {
        return [
          ...state,
          {
            title: `Output ${numberOfOutputLines + 1}`,
            type: "output",
            content: action.payload.content.text,
            index: action.payload.content.index,
            inferenceBlockCount: action.payload.content.inferenceBlockCount,
            isForEndUser: action.payload.content.isForEndUser,
          },
        ];
      } else {
        existing.content += action.payload.content.text;
        return [...state];
      }
    case "reset":
      return initialState;
    case "error":
      return [...state, { type: "error", content: action.payload.message }];
    default:
      return state;
  }
};

export const useTestResultReducer = () => useReducer(reducer, initialState);
